import HTTP from "@/network/request.js";
import API from "@/network/api.js";
// 1.获取基本配置
export async function CreateAccount(params) {
  let response = await HTTP.post(API.CreateAccount, null, {
    params: params,
  });
  return response;
}

// 2.进入游戏
export async function LoginGame(params) {
  let response = await HTTP.post(API.LoginGame, null, {
    params: params,
  });
  return response;
}

// 3.用戶充值
export async function PayAccount(params) {
  let response = await HTTP.post(API.PayAccount, null, {
    params: params,
  });
  return response;
}
